import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitlabIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	"aria-hidden": "true",
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#e24329",
			d: "m24.51 9.5-.03-.09L21.08.56a.9.9 0 0 0-1.69.09l-2.29 7.01H7.83L5.54.65a.9.9 0 0 0-1.69-.09L.45 9.41.42 9.5a6.3 6.3 0 0 0 2.09 7.28l.01.01.03.02 5.16 3.87 2.56 1.94 1.55 1.18a1.05 1.05 0 0 0 1.27 0l1.55-1.18 2.56-1.94 5.2-3.89.01-.01A6.3 6.3 0 0 0 24.51 9.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fc6d26",
			d: "m24.51 9.5-.03-.09a11.44 11.44 0 0 0-4.56 2.05l-7.45 5.63 4.74 3.58 5.2-3.89.01-.01A6.3 6.3 0 0 0 24.51 9.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fca326",
			d: "m7.71 20.68 2.56 1.94 1.55 1.18a1.05 1.05 0 0 0 1.27 0l1.55-1.18 2.56-1.94-4.74-3.58-4.75 3.58z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fc6d26",
			d: "M5.01 11.46a11.43 11.43 0 0 0-4.56-2.05L.42 9.5a6.3 6.3 0 0 0 2.09 7.28l.01.01.03.02 5.16 3.87 4.75-3.58-7.44-5.63z"
		})
	]
});
export default SvgGitlabIcon;
